// extracted by mini-css-extract-plugin
export default {"ourMission":"Mission_ourMission__b48L6"};